module.exports = __webpack_public_path__ + "app/modals/preview-message.view.html";